<template>
  <div id="manager-salary">
    <div class="table-add">
      <el-button @click="openSalaryDialog('add')" size="medium" type="primary"
        >生成薪资结算表</el-button
      >
    </div>
    <div class="table-container">
      <el-table :data="salaryReportList" stripe style="width: 100%">
        <el-table-column prop="name" label="结算表名称"> </el-table-column>
        <el-table-column prop="remark" label="备注"> </el-table-column>
        <el-table-column prop="created_at" label="创建日期"> </el-table-column>
        <el-table-column label="操作" width="350">
          <template slot-scope="scope">
            <el-button
              size="small"
              @click="openSalaryDialog('info', scope.row)"
              type="primary"
              >编辑</el-button
            >
            <el-button
              size="small"
              @click="openSalaryDialog('detail', scope.row.id)"
              type="primary"
              >详情</el-button
            >
            <el-button
              size="small"
              @click="getDownloadData(scope.row.id, scope.row.name)"
              type="primary"
              >导出</el-button
            >
            <el-button
              size="small"
              @click="deleteSalaryReport(scope.row)"
              type="danger"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="table-page">
        <el-pagination
          small
          layout="prev, pager, next"
          :total="total_count"
          :current-page="page"
          @current-change="getSalaryReportList"
        >
        </el-pagination>
      </div>
    </div>
    <salaryAdd
      :salaryDialogType.sync="salaryDialogType"
      @updateSalaryList="getSalaryReportList"
    />
    <salaryInfo
      :salaryDialogType.sync="salaryDialogType"
      :reportData="dialogData"
      @updateSalaryList="getSalaryReportList"
    />
    <salaryDetail
      :salaryDialogType.sync="salaryDialogType"
      :reportId="dialogData"
    />
  </div>
</template>

<script>
import {
  managerSalaryReportList,
  managerDeleteSalaryReport,
  managerSalaryReportDetail,
} from '@/api/manager'
import salaryAdd from './components/add'
import salaryInfo from './components/info'
import salaryDetail from './components/detail'
import { implantExcel } from '@/utils/common'
export default {
  name: 'manager-salary',
  components: {
    salaryAdd,
    salaryInfo,
    salaryDetail,
  },
  data() {
    return {
      dialogData: 0,
      salaryDialogType: '',
      salaryReportList: [],
      total_count: 0,
      page: 1,
    }
  },
  mounted() {
    this.getSalaryReportList()
  },
  methods: {
    async getSalaryReportList(_page = 1) {
      this.page = _page
      let { code, result } = await managerSalaryReportList({ page: this.page })
      if (code == this.CONFIG.CODE_SUCCESS) {
        this.salaryReportList = result.list
        this.total_count = result.total_count
      }
    },
    openSalaryDialog(_type, _id) {
      this.salaryDialogType = _type
      this.dialogData = _id
    },
    deleteSalaryReport(_row) {
      this.$confirm(
        '此操作将删除该报表"' + _row.name + '", 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      )
        .then(async () => {
          let { code, result } = await managerDeleteSalaryReport({
            id: _row.id,
          })
          if (code == this.CONFIG.CODE_SUCCESS) {
            this.getSalaryReportList(this.page)
            this.$message({
              type: 'success',
              message: msg,
            })
          }
        })
        .catch(() => {})
    },
    async getDownloadData(_id, _name) {
      let { code, result } = await managerSalaryReportDetail({
        report_id: _id,
      })
      if (code == this.CONFIG.CODE_SUCCESS) {
        this.downloadExcel(result, _name)
      }
    },
    downloadExcel(_list, _name) {
      let thead = [
          '姓名',
          '所属公司',
          '银行名称',
          '银行卡号',
          '支行',
          '薪资',
          '奖金',
          '补贴',
          '社保缴纳',
          '公积金',
          '个人所得税',
          '请假扣除',
          '迟到扣除',
          '额外调整',
          '实发薪资',
          '基本工资',
          '绩效工资',
        ],
        trContent = ''
      _list.forEach((item) => {
        trContent += `<tr>
          <td>${item.staff_real_name}</td>
          <td>${item.company_name}</td>
          <td>${item.bank_name}</td>
          <td style="vnd.ms-excel.numberformat:@">${item.bankcard_num}</td>
          <td>${item.bankcard_info}</td>
          <td>${item.contract_salary}</td>
          <td>${item.bonus}</td>
          <td>${item.allowance}</td>
          <td>${item.social_insurance}</td>
          <td>${item.housing_fund}</td>
          <td>${item.income_tax}</td>
          <td>${item.deduct_for_leave}</td>
          <td>${item.deduct_for_late}</td>
          <td>${item.extra}</td>
          <td>${item.final_salary}</td>
          <td>${item.part_a_salary}</td>
          <td>${item.part_b_salary}</td>
        </tr>`
      })
      implantExcel(thead, trContent, _name)
    },
  },
}
</script>

<style lang="less" scoped>
.table-container {
  width: 100%;
}
.table-add {
  margin: 7px 0 15px 0;
}
.table-container {
  padding: 8px;
  background: #fff;
  border-radius: 5px;
}
.table-page {
  margin-top: 15px;
  text-align: center;
}
</style>
